import React from "react";
const legalLinks = [{
  label: "Terms of Service",
  href: "#terms"
}, {
  label: "Privacy Policy",
  href: "#privacy"
}, {
  label: "Refund Policy",
  href: "#refund"
}];
export function SiteFooter() {
  return <footer className="border-t border-line" data-id="element-236" data-mp="3mghmewvxqlpr">
      <div className="mx-auto max-w-7xl px-5 pb-28 pt-10 sm:px-6 md:py-12" data-id="element-237" data-mp="3mf6gorixj3w0">
        <div className="flex flex-col gap-8 md:flex-row md:items-start md:justify-between" data-id="element-238" data-mp="3hi6b0hpzs35f">
          <div className="max-w-md" data-id="element-239" data-mp="3difnqnzoc55n">
            <p className="font-display text-xl font-black tracking-tight" data-id="element-240" data-mp="38hrndbpk2byr">
              CLARIFY<span className="text-accent" data-id="element-241" data-mp="38jup2t02ltjb">.</span>
            </p>
            <p className="mt-3 text-sm leading-relaxed text-mute" data-id="element-242" data-mp="33jgfv7mqgdjp">
              Luis Coa LLC provides digital educational products, online courses, and professional services as described on this website.
            </p>
          </div>
          <div className="flex flex-col gap-4 text-sm md:items-end" data-id="element-243" data-mp="11oxxy1peuu8a">
            <nav aria-label="Legal" className="flex flex-wrap gap-x-5 gap-y-2" data-id="element-244" data-mp="wsqq23dgf8np">
              {legalLinks.map(link => <a key={link.label} href={link.href} className="text-paper/80 transition-colors duration-150 ease-out hover:text-accent" data-id="element-245" data-mp="15sy6064q1guh">
                  {link.label}
                </a>)}
            </nav>
            <p className="text-mute" data-id="element-246" data-mp="10rim4hea5gdo">
              Contact:{" "}
              <a href="mailto:atencion@luiscoa.com" className="text-paper/80 transition-colors duration-150 ease-out hover:text-accent" data-id="element-247" data-mp="10tv24p0h9go3">
                atencion@luiscoa.com
              </a>
            </p>
          </div>
        </div>
        <p className="mt-10 border-t border-line pt-6 text-xs text-mute" data-id="element-248" data-mp="1ertcljbogsyb">CLARIFY © 2026 Luis Coa LLC. All rights reserved.</p>
      </div>
    </footer>;
}